import React, { useCallback, useRef, useState } from 'react'
import { NavigationSearchProps } from './types'

export const NavigationSearch = ({ searchUrl }: NavigationSearchProps): JSX.Element => {
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLFormElement | null>(null)

  const showSearch = useCallback(() => {
    document.querySelector('header')?.classList.add('search-is-open')
    setOpen(true)
  }, [])

  const submitSearch = useCallback(() => ref.current?.submit(), [])
  if (!open) return <i className="header-search-icon fa fa-search" onClick={showSearch}></i>

  return (
    <form action={searchUrl} method="POST" ref={ref}>
      <input
        className="form-control"
        autoFocus
        name="query"
        placeholder={I18n.t('layouts.header.search_placeholder')}
      />

      <i className="fa fa-search header-search-icon" onClick={submitSearch}></i>
    </form>
  )
}
